import React from 'react';
import {brandConfig} from '../../utils';

import './styles.scss';

export const TermsAndConditions = () => {
  if (brandConfig.isAffiliate) {
    return null;
  }

  return (
    <div className="userEditModalTermsAndConditions">
      <span>By clicking save you agree to our</span>{' '}
      <a href={`https://cuegrowth.ai/terms`} target="_blank" rel="noreferrer noopener">
        Terms of Use
      </a>{' '}
      <span>and</span>{' '}
      <a href={`https://cuegrowth.ai/privacy`} target="_blank" rel="noreferrer noopener">
        Privacy Policy
      </a>
    </div>
  );
};
